import { render, staticRenderFns } from "./PopupSwitchDashboardLayout.vue?vue&type=template&id=a4024d68"
import script from "./PopupSwitchDashboardLayout.vue?vue&type=script&lang=js"
export * from "./PopupSwitchDashboardLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports